import { Injectable } from '@angular/core';
import { GridCategoriesTitle } from './grid-categories.model';

@Injectable({
  providedIn: 'root',
})
export class GridCategoriesService {
  constructor() {}

  normalizeTitle(data: any): GridCategoriesTitle {
    const title: GridCategoriesTitle = {
      action: {
        label: ``,
        url: ``,
      },
    };

    if (data.line1) {
      title.line1 = data.line1;
    }

    if (data.line2) {
      title.line2 = data.line2;
    }

    if (data?.action?.url && data?.action?.linkName) {
      title.action!.label = data.action.linkName;
      title.action!.url = data.action.url;
    }

    return title;
  }
}
